import store from '@/store'

export function hasPermission(permission) {
  const permissions = store.state.user.permissions
  return permissions && permissions.includes(permission)
}

export default {
  inserted(el, binding) {
    const { value } = binding
    if (value && !hasPermission(value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
